import {useGoogleLogin} from '@react-oauth/google';
import React, {type JSX} from 'react';

import {TEXT} from './googleSignIn.definition';

import {useIntl} from 'react-intl';
import {GoogleButton} from './components/GoogleButton';
import {GoogleSignInButtonProps} from './GoogleSignInButton.types';

export const GoogleSignInButton = ({
  busy,
  onGoogleSignIn,
  onGoogleSignInFail,
}: GoogleSignInButtonProps): JSX.Element => {
  const {formatMessage} = useIntl();

  const handleGoogleSignin = useGoogleLogin({
    onSuccess: async tokenResponse => {
      onGoogleSignIn({token: tokenResponse.code});
    },
    onError: error => {
      if (onGoogleSignInFail) onGoogleSignInFail(error);
    },
    flow: 'auth-code',
  });

  return (
    <GoogleButton
      busy={busy}
      onButtonPressed={handleGoogleSignin}
      label={formatMessage(TEXT.GOOGLE_LOGIN_CTA)}
      testID="google-button"
    />
  );
};
